import {ApiCollection} from "./api.collection";
import {AdditionalFee} from "../models/additional-fee.model";


export const AdditionalFees = ApiCollection.extend({
    model: AdditionalFee,
    url: 'api/additional_fees',
});
